import { getCheckoutState } from 'merchant-api/checkout';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useEffect } from 'react';
import { checkout } from '..';

interface DisclosureProps {
  isLoadingDisclosure: boolean;
  isErrorDisclosure: boolean | null;
  openDisclosurePdf: () => void;
  mutation: UseMutationResult<string, Error, void>;
}

export function getDisclosure(): DisclosureProps {
  const apiUrl = import.meta.env['VITE_CHECKOUT_ORCHESTRATOR_URL'];
  const { isLoadingCheckoutState, isErrorCheckoutState, checkoutData } =
    getCheckoutState();

  const mutation = useMutation({
    mutationFn: async () => {
      return checkout
        .get(`/v1/disclosures/${checkoutData?.checkoutUuid}`, {
          responseType: 'text',
        })
        .then((res) => res.data);
    },
    mutationKey: ['getDisclosure', checkoutData?.checkoutUuid],
  });

  const openNewWindow = () =>
    window.open(
      `${apiUrl}/v1/disclosures/${checkoutData?.checkoutUuid}`,
      '_blank',
      'noopener,noreferrer',
    );

  const openDisclosurePdf = () =>
    mutation.data ? openNewWindow() : mutation.mutate();

  useEffect(() => {
    mutation.data && openNewWindow();
  }, [mutation.data]);

  return {
    isLoadingDisclosure: mutation.isPending || isLoadingCheckoutState,
    isErrorDisclosure: mutation.error || isErrorCheckoutState,
    openDisclosurePdf,
    mutation,
  };
}
